import React from 'react';
// import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import {grey500} from 'material-ui/styles/colors';
import {Field, reduxForm} from 'redux-form'

import FormText from '../../components/FormText'

const styles = {
  checkRemember: {
    style: {
      float: 'left',
      maxWidth: 180,
      paddingTop: 5
    },
    labelStyle: {
      color: grey500
    },
    iconStyle: {
      color: grey500,
      borderColor: grey500,
      fill: grey500
    }
  },
  loginBtn: {
    float: 'right'
  },
};


const validate = values => {
  const errors = {}
  const requiredFields = [
    'email',
    'password'
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })
  return errors
}

class LoginForm extends React.Component {

  render() {

    const {
      error,
      handleSubmit,
      submitting,
      pristine,
      onLogin,
    } = this.props

    return (

      <form onSubmit={handleSubmit(onLogin)}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        <Field
          name="email"
          component={FormText}
          label="ログインID"
          fullWidth={true}
        />
        <Field
          name="password"
          component={FormText}
          label="パスワード"
          fullWidth={true}
          type="password"
        />

        <div style={{marginTop: 30}}>
          {/*<Checkbox
            label="Remember me"
            style={styles.checkRemember.style}
            labelStyle={styles.checkRemember.labelStyle}
            iconStyle={styles.checkRemember.iconStyle}
          />*/}

          <RaisedButton label="ログイン"
            primary={true}
            fullWidth={true}
            type="submit"
            style={styles.loginBtn} />

        </div>
      </form>

  )
  }
}

LoginForm = reduxForm({
  form: 'loginForm',
  validate
})(LoginForm)

export default LoginForm;



// WEBPACK FOOTER //
// ./src/containers/auth/LoginForm.js